import * as React from 'react';
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
const IconUploadYourArtwork = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  role: "img"
}, props), /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 3,
  width: 22,
  height: 22,
  rx: 11,
  stroke: "black",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.0007 15.3333V17.3533C9.98788 17.5689 10.151 17.9999 10.9058 17.9999C11.6605 17.9999 15.4969 17.9999 17.3207 17.9999C17.5471 17.9949 18 17.8585 18 17.3533C18 16.8482 18 15.7961 18 15.3333",
  stroke: "black",
  strokeWidth: 1.5,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14 9L14.0009 15",
  stroke: "black",
  strokeWidth: 1.5,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 10.875L14 9L16 10.875",
  stroke: "black",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
export { IconUploadYourArtwork };